import { styled } from '@slal/ui';
import { Field } from '../Form/styles';

export const SliderField = styled(Field)`
    label {
        font-weight: 400;
        font-family: 'Arial', sans-serif;

        span {
            font-size: 16px;
            color: ${({ theme }) => theme.colors.neutral__light__80};
        }
    }
    input[type='text'] {
        width: 100px;
    }
    input[type='range'] {
        flex-grow: 1;
    }

    div[role='group'] > div {
        flex-grow: 0;
        margin-right: 8px;
    }
`;

export const InputWrapper = styled.div`
    display: inline-flex;
    align-items: center;
    width: 100%;
`;

export const StyledRangeInput = styled.input.attrs<{ fillPercentage: number }>(({ fillPercentage }) => ({
    style: {
        ['--fill-percentage' as string]: `${fillPercentage}%`,
    } as React.CSSProperties,
}))`
    width: 100%;
    height: 4px !important;
    -webkit-appearance: none;
    background: transparent;

    /* WebKit Track */
    &::-webkit-slider-runnable-track {
        height: 4px;
        background: linear-gradient(90deg, #147cb3 var(--fill-percentage), #e2e6ee var(--fill-percentage));
    }

    /* Firefox Track */
    &::-moz-range-track {
        height: 4px;
        background: linear-gradient(90deg, #147cb3 var(--fill-percentage), #e2e6ee var(--fill-percentage));
    }

    /* WebKit Thumb (Knob) */
    &::-webkit-slider-thumb {
        -webkit-appearance: none;
        width: 24px;
        height: 24px;
        background-color: #fff;
        border-radius: 50%;
        border: 2px solid ${({ theme }) => theme.colors.blue__secondary__70};
        cursor: pointer;
        transform: translateY(-10px);
    }

    /* Firefox Thumb */
    &::-moz-range-thumb {
        -webkit-appearance: none;
        width: 24px;
        height: 24px;
        background-color: #fff;
        border-radius: 50%;
        border: 2px solid ${({ theme }) => theme.colors.blue__secondary__70};
        cursor: pointer;
    }
`;
